import { useState } from "react";
import { apiRequest, ApiError, setRefreshToken } from "../../api/client";

export default function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const mismatch = confirm.length > 0 && next !== confirm;

  async function save() {
    setBusy(true);
    setError(null);
    try {
      const res = await apiRequest<{ refreshToken: string }>("/auth/change-password", {
        method: "POST",
        body: { currentPassword: current, newPassword: next },
      });
      // Every other device is signed out by a password change; this one keeps working.
      setRefreshToken(res.refreshToken);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not change the password");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Change my password</h2>
        {done ? (
          <>
            <p>Your password was changed. Any other devices where you were signed in have been signed out.</p>
            <div className="modal-actions">
              <button className="btn-primary" onClick={onClose}>
                Done
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="stack">
              <div className="field">
                <label>Current password</label>
                <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus autoComplete="current-password" />
              </div>
              <div className="field">
                <label>New password (at least 10 characters)</label>
                <input type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" />
              </div>
              <div className="field">
                <label>Repeat the new password</label>
                <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
              </div>
              {mismatch && <div className="error-banner">The two new passwords don't match.</div>}
              {error && <div className="error-banner">{error}</div>}
            </div>
            <div className="modal-actions">
              <button className="btn-ghost" onClick={onClose}>
                Cancel
              </button>
              <button className="btn-primary" disabled={busy || !current || next.length < 10 || next !== confirm} onClick={save}>
                {busy ? "Saving…" : "Change password"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
